export default __webpack_public_path__ + "static/media/app_image_2_small.e3d82360.png";